'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getFileUploadPolicy = getFileUploadPolicy;
exports.getFileUploadPolicyForDesigner = getFileUploadPolicyForDesigner;
exports.downloadTemplateForDesigner = downloadTemplateForDesigner;
exports.form_registerFileUsingPost = form_registerFileUsingPost;
exports.initRequestParams = initRequestParams;
exports.initRequestParamsForDesigner = initRequestParamsForDesigner;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _requestOlympics2.default;


var parseSearch = function parseSearch(url) {
  var regex = /[^&=?]+=[^&]*/g;
  var paramArr = url.match(regex);
  var param = {};
  paramArr && paramArr.forEach(function (item) {
    var pairs = item.split('=');
    param[pairs[0]] = pairs[1];
  });
  return param;
};

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}

/**
 * 上传文件到OSS
 */
function getFileUploadPolicy() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var fileUploadUrl = config.fileUploadUrl || '/form/file/getFileUploadPolicy';
  return _requestOlympics2.default.get((0, _request.transformUrl)(fileUploadUrl), {
    params: _extends({}, config, {
      timestamp: new Date().getTime()
    })
  }).then(function (res) {
    return resErrorJudge(res);
  });
}

function getFileUploadPolicyForDesigner() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var fileUploadUrl = config.fileUploadUrl || '/gov/form/file/getFileUploadPolicy';
  return _requestOlympics2.default.get((0, _request.transformUrl)(fileUploadUrl), {
    params: _extends({}, config, {
      timestamp: new Date().getTime()
    })
  }).then(resErrorJudge);
}

function downloadTemplateForDesigner(params) {
  return _requestOlympics2.default.get((0, _request.urlPrefix)() + '/rest/api/form/downloadTemplate', { params: _extends({}, params, { timestamp: new Date().getTime() }) }).then(resErrorJudge);
}

function form_registerFileUsingPost(fileName, filePath) {
  return _requestOlympics2.default.post((0, _request.urlPrefix)() + '/form/file/registerFile', { fileName: fileName, filePath: filePath }).then(resErrorJudge);
}

/** 从url中获取参数 */
function initRequestParams(fieldId, global) {
  var params = global && global.params || {};
  return _extends({}, params, {
    matterType: params.matterType || window.matterType,
    matterId: params.matterId,
    endpoint: params.endpoint,
    sequenceNo: params.sequenceNo || window.sequenceNo,
    tablePropertyId: fieldId
  });
}

function initRequestParamsForDesigner(fieldId) {
  var params = parseSearch(window.location.href);
  return _extends({}, params, {
    matterType: params.matterType || window.matterType,
    matterId: params.matterId,
    endpoint: params.endpoint,
    sequenceNo: params.sequenceNo || window.sequenceNo,
    tablePropertyId: fieldId
  });
}